<template>
	<div>
		<!--编辑 -->
		<el-dialog :title="isEdit?'积分规则':'积分规则'" :visible.sync="dialog" @close="unShowClick()" width="50%">
			<el-form ref="addBody" :rules="rules" :model="addBody">
				<el-form-item label="" prop="name" :label-width="formLabelWidth" v-if="activeName == 'zh'">
					<QuillEditor :value="value" @input='editorInput'></QuillEditor>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="unShowClick()">取 消</el-button>
				<el-button type="primary" @click="updateConfigList('addBody')">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import QuillEditor from '@/components/quill-editor'
	import {
		updateConfigList,
		getConfigDetail
	} from '@/api/marketing'
	import ImageUpload from "@/components/ImageUpload"
	// import { getAuthListDetail, identityOf, editAuthUser } from '@/api/auth'

	export default {
		props: {
			dialogProp: {
				type: Boolean,
				default: false,
			},
		},
		components: {
			ImageUpload,
			QuillEditor
		},
		data() {
			return {
				inputValue:'',
				value:'',
				activeName: 'zh',
				readid: '',
				dialog: false,
				identTable: [],
				formLabelWidth: '120px',
				isAddAdmin: true,
				addBody: {
					identity: '',
					name: '',
					phone: "",
					account: "",
					password: '',
				},
				images: [],
				rules: {
				},
				weightList: [],
				weight: '',
				isEdit: false,
				lmList: [{
						id: 1,
						name: '用户'
					},
					{
						id: 2,
						name: '管理员'
					},
				]
			}
		},
		mounted() {
			
		},
		methods: {
			editorInput(e){
				this.inputValue = e
			},
			validatePassword(password) {
				const lengthValid = password.length >= 8;
				const hasUpperCase = /[A-Z]/.test(password);
				const hasLowerCase = /[a-z]/.test(password);
				const hasNumber = /\d/.test(password);
				const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
				const criteriaMet = [hasUpperCase, hasLowerCase, hasNumber, hasSpecialChar].filter(Boolean).length >= 2;
				return lengthValid && criteriaMet;
			},
			handleImageListChange(list) {
				this.images = list
			},
			isSaleChange(e) {
				this.weight = e
			},
			changeItem(item) {
			},
			updateConfigList(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (this.isEdit) {
							this.network().updateConfigList()
						} else {
							this.network().updateConfigList()
						}
					} else {
						return false;
					}
					return false
				});
			},
			unShowClick() {
				this.$emit('input', false)
			},
			network() {
				return {
					updateConfigList: async () => {
						const {
							status
						} = await updateConfigList({
							value:this.inputValue,
							key:'SCORE_RULE'
						})
						if (status !== 200) return
						this.dialog = false
						this.$emit('confirm')
						this.$message.success('修改成功')
					},
					getConfigDetail: async (uuid) => {
						const {
							data,
							status
						} = await getConfigDetail({
							key:'SCORE_RULE'
						})
						if (status !== 200) return
						this.value = data.result.value
					},
				}
			},
		},

		watch: {
			value(newVal, oldVal) {
				
			},
			dialogProp(old) {
				this.network().getConfigDetail()
				this.dialog = old;
			},
		},
	};
</script>

<style scoped>
</style>